import { css, html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { areNotesCollapsed } from "./shared";

@customElement("od-note")
export class OutDesignNoteElement extends LitElement {
    @property({ type: Boolean, reflect: true }) collapsed: boolean = areNotesCollapsed();


    static styles = css`
        :host([collapsed]) {
            display: inline;
        }
        :host(:not([collapsed])) {
            display: block;
        }
        sup {
            color: blue;
            cursor: pointer;
            line-height: 0;
        }
    `;

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("toggle-notes-collapse", this.toggleCollapse);
    }

    disconnectedCallback() {
        document.removeEventListener("toggle-notes-collapse", this.toggleCollapse);
        super.disconnectedCallback();
    }

    private toggleCollapse = () => {
        if(this.collapsed != areNotesCollapsed()) {
            this.collapsed = !this.collapsed
        }
        console.log(this.collapsed)
    }

    private expandNote() {
        this.collapsed = false;
    }

    private renderCollapsed() {
        return html`<sup @click=${this.expandNote}>[Note]</sup>`;
    }

    private renderFull() {
        return html`
            <div data-role="note-wrapper">
                <slot></slot>
            </div>
        `;
    }

    render() {
        return this.collapsed ? this.renderCollapsed() : this.renderFull();
    }
}